import React from 'react';
import { PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { LayeredModalProvider } from '../components/molecules/modal/layered-modal';
import { SteppedProvider } from '../components/molecules/modal/stepped-modal';
import { FeatureFlagProvider as FeatureFlagProviderV1 } from './feature-flag-provider';
import { FeatureFlagProvider as FeatureFlagProviderV2 } from './feature-flag-provider-v2';
import { MedusaProvider } from './medusa-provider';
import { PollingProvider } from './polling-provider';
import { OrderSelectionProvider } from './order-selection-provider';
import { PersistentMessagesProvider } from './persistent-messages-provider';

/**
 * This component wraps all providers into a single component.
 */
export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <HelmetProvider>
      <MedusaProvider>
        <FeatureFlagProviderV1>
          <FeatureFlagProviderV2>
            <PollingProvider>
              <SteppedProvider>
                <LayeredModalProvider>
                  <OrderSelectionProvider>
                    <PersistentMessagesProvider>
                      {children}
                    </PersistentMessagesProvider>
                  </OrderSelectionProvider>
                </LayeredModalProvider>
              </SteppedProvider>
            </PollingProvider>
          </FeatureFlagProviderV2>
        </FeatureFlagProviderV1>
      </MedusaProvider>
    </HelmetProvider>
  );
};
